"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f105 = void 0;
exports.f105 = {
    "ia": [
        "Latn"
    ],
    "iai": [
        "Latn"
    ],
    "ian": [
        "Latn"
    ],
    "iap": [
        "Latn"
    ],
    "iar": [
        "Latn"
    ],
    "iba": [
        "Latn"
    ],
    "ibb": [
        "Latn"
    ],
    "ibd": [
        "Latn"
    ],
    "ibe": [
        "Latn"
    ],
    "ibg": [
        "Latn"
    ],
    "ibh": [
        "Latn"
    ],
    "ibl": [
        "Latn"
    ],
    "ibm": [
        "Latn"
    ],
    "ibn": [
        "Latn"
    ],
    "ibr": [
        "Latn"
    ],
    "ibu": [
        "Latn"
    ],
    "iby": [
        "Latn"
    ],
    "ica": [
        "Latn"
    ],
    "ich": [
        "Latn"
    ],
    "icl": [
        "Zxxx"
    ],
    "icr": [
        "Latn"
    ],
    "id": [
        "Latn",
        "Arab",
        "Brai"
    ],
    "ida": [
        "Latn"
    ],
    "idb": [
        "Latn"
    ],
    "idc": [
        "Latn"
    ],
    "idd": [
        "Latn"
    ],
    "ide": [
        "Latn"
    ],
    "idi": [
        "Latn"
    ],
    "idr": [
        "Latn"
    ],
    "ids": [
        "Latn"
    ],
    "idt": [
        "Latn"
    ],
    "idu": [
        "Latn"
    ],
    "ie": [
        "Latn"
    ],
    "ifa": [
        "Latn"
    ],
    "ifb": [
        "Latn"
    ],
    "ife": [
        "Latn"
    ],
    "iff": [
        "Latn"
    ],
    "ifk": [
        "Latn"
    ],
    "ifm": [
        "Latn"
    ],
    "ifu": [
        "Latn"
    ],
    "ify": [
        "Latn"
    ],
    "ig": [
        "Latn"
    ],
    "igb": [
        "Latn"
    ],
    "ige": [
        "Latn"
    ],
    "igg": [
        "Latn"
    ],
    "igl": [
        "Latn"
    ],
    "igm": [
        "Latn"
    ],
    "ign": [
        "Latn"
    ],
    "igo": [
        "Latn"
    ],
    "igs": [
        "Latn",
        "Grek"
    ],
    "igw": [
        "Latn"
    ],
    "ihb": [
        "Latn"
    ],
    "ihi": [
        "Latn"
    ],
    "ihp": [
        "Latn"
    ],
    "ihw": [
        "Latn"
    ],
    "ii": [
        "Yiii",
        "Latn"
    ],
    "iin": [
        "Latn"
    ],
    "ijc": [
        "Latn"
    ],
    "ije": [
        "Latn"
    ],
    "ijj": [
        "Latn"
    ],
    "ijn": [
        "Latn"
    ],
    "ijs": [
        "Latn"
    ],
    "ik": [
        "Latn"
    ],
    "ike": [
        "Latn"
    ],
    "iki": [
        "Latn"
    ],
    "ikk": [
        "Latn"
    ],
    "ikl": [
        "Latn"
    ],
    "iko": [
        "Latn"
    ],
    "ikp": [
        "Latn"
    ],
    "ikr": [
        "Latn"
    ],
    "iks": [
        "Zxxx"
    ],
    "ikt": [
        "Latn",
        "Cans"
    ],
    "ikv": [
        "Latn"
    ],
    "ikw": [
        "Latn"
    ],
    "ikx": [
        "Latn"
    ],
    "ikz": [
        "Latn"
    ],
    "ila": [
        "Latn"
    ],
    "ilb": [
        "Latn"
    ],
    "ilg": [
        "Latn"
    ],
    "ili": [
        "Zyyy"
    ],
    "ilk": [
        "Latn"
    ],
    "ilm": [
        "Latn"
    ],
    "ilo": [
        "Latn",
        "Brai",
        "Tglg"
    ],
    "ilp": [
        "Latn"
    ],
    "ils": [
        "Zxxx"
    ],
    "ilu": [
        "Latn"
    ],
    "ilv": [
        "Latn"
    ],
    "ima": [
        "Zyyy"
    ],
    "imi": [
        "Latn"
    ],
    "iml": [
        "Zyyy"
    ],
    "imn": [
        "Latn"
    ],
    "imo": [
        "Latn"
    ],
    "imr": [
        "Latn"
    ],
    "ims": [
        "Latn"
    ],
    "imy": [
        "Lyci"
    ],
    "inb": [
        "Latn"
    ],
    "ing": [
        "Latn"
    ],
    "inh": [
        "Cyrl",
        "Arab",
        "Latn"
    ],
    "inj": [
        "Latn"
    ],
    "inl": [
        "Zxxx"
    ],
    "inm": [
        "Zyyy"
    ],
    "inn": [
        "Latn"
    ],
    "ino": [
        "Latn"
    ],
    "inp": [
        "Latn"
    ],
    "ins": [
        "Zxxx"
    ],
    "int": [
        "Mymr"
    ],
    "inz": [
        "Zyyy"
    ],
    "io": [
        "Latn"
    ],
    "ior": [
        "Ethi"
    ],
    "iou": [
        "Latn"
    ],
    "iow": [
        "Zyyy"
    ],
    "ipi": [
        "Latn"
    ],
    "ipo": [
        "Latn"
    ],
    "iqu": [
        "Latn"
    ],
    "iqw": [
        "Latn"
    ],
    "ire": [
        "Latn"
    ],
    "irh": [
        "Latn"
    ],
    "iri": [
        "Latn"
    ],
    "irk": [
        "Latn"
    ],
    "irn": [
        "Latn"
    ],
    "irr": [
        "Zyyy"
    ],
    "iru": [
        "Taml",
        "Mlym"
    ],
    "irx": [
        "Latn"
    ],
    "iry": [
        "Latn"
    ],
    "is": [
        "Latn"
    ],
    "isa": [
        "Latn"
    ],
    "isc": [
        "Latn"
    ],
    "isd": [
        "Latn"
    ],
    "ise": [
        "Zxxx"
    ],
    "isg": [
        "Zxxx"
    ],
    "ish": [
        "Latn"
    ],
    "isi": [
        "Latn"
    ],
    "isk": [
        "Arab"
    ],
    "ism": [
        "Latn"
    ],
    "isn": [
        "Latn"
    ],
    "iso": [
        "Latn"
    ],
    "isr": [
        "Zxxx"
    ],
    "ist": [
        "Latn"
    ],
    "isu": [
        "Latn"
    ],
    "it": [
        "Latn",
        "Brai"
    ],
    "itb": [
        "Latn"
    ],
    "itd": [
        "Latn"
    ],
    "ite": [
        "Latn"
    ],
    "iti": [
        "Latn"
    ],
    "itk": [
        "Hebr"
    ],
    "itl": [
        "Cyrl"
    ],
    "itm": [
        "Latn"
    ],
    "ito": [
        "Latn"
    ],
    "itr": [
        "Latn"
    ],
    "its": [
        "Latn"
    ],
    "itt": [
        "Latn"
    ],
    "itv": [
        "Latn"
    ],
    "itw": [
        "Latn"
    ],
    "itx": [
        "Latn"
    ],
    "ity": [
        "Latn"
    ],
    "itz": [
        "Latn"
    ],
    "iu": [
        "Cans",
        "Latn"
    ],
    "ium": [
        "Latn",
        "Hani",
        "Laoo",
        "Thai"
    ],
    "ivb": [
        "Latn"
    ],
    "ivv": [
        "Latn"
    ],
    "iwk": [
        "Latn"
    ],
    "iwm": [
        "Latn"
    ],
    "iwo": [
        "Latn"
    ],
    "iws": [
        "Latn"
    ],
    "ixc": [
        "Latn"
    ],
    "ixl": [
        "Latn"
    ],
    "iya": [
        "Latn"
    ],
    "iyo": [
        "Latn"
    ],
    "iyx": [
        "Latn"
    ],
    "izh": [
        "Latn"
    ],
    "izr": [
        "Latn"
    ],
    "izz": [
        "Latn"
    ]
};
